<template>
  <div id="homeclass-faq">
    <BottomBar />
    <div :class="{ noscroll: isShowPopup }" class="container">
      <h1>了解同城拼课</h1>
      <div v-for="item in list" :key="item.title" class="question">
        <h2 @click="popup(item)">{{ item.title }}</h2>
      </div>
    </div>
    <Popup v-if="isShowPopup" :msg="popupMsg" @close="isShowPopup = false" />
  </div>
</template>
<script>
import faqModule from "./faqModule"
import Popup from "../public/Popup.vue"
import BottomBar from "../public/footer.vue"
export default {
  name: "HomeclassFaq",
  components: {
    Popup,
    BottomBar,
  },
  data() {
    return {
      list: [],
      isShowPopup: false,
      popupMsg: "",
    }
  },
  created() {
    this.list = faqModule.dump()
  },
  methods: {
    popup(msg) {
      this.popupMsg = msg
      this.isShowPopup = true
    },
  },
}
</script>
<style scoped lang="scss">
// @import "../../../static/css/public.scss";

@import "../../../static/css/prog-form.scss";
#homeclass-faq {
  min-height: 100vh;
  background: white;
  width: 100%;
  @include avenir();
  .container {
    * {
      color: $black;
    }
    h1 {
      font-size: 13px;
      font-weight: bold;
      padding-top: 80px;
      padding-bottom: 25px;
      padding: 80px 5% 0px 5%;
      letter-spacing: 4px;
    }
    .question {
      width: 100%;
      h2 {
        font-size: 15px;
        font-weight: 300;
        padding: 20px 0;
        margin: 0 0 0 5%;
        border-bottom: 1px solid #eee;
        font-weight: bold;
        padding: 10px 0 5px 0;
        font-size: 20px;
        color: $blue;
      }
      &:active {
        background: #f7f7f7;
      }
    }
  }
}
</style>
